/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie`
};

const en_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Discover`
};

const es_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra`
};

const fr_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrir`
};

const it_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Scoprire`
};

const nl_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdek`
};

const pt_launchpad__zois_cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Descobrir`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__zois_cta_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__zois_cta_label", locale)
	if (locale === "de") return de_launchpad__zois_cta_label(inputs)
	if (locale === "en") return en_launchpad__zois_cta_label(inputs)
	if (locale === "es") return es_launchpad__zois_cta_label(inputs)
	if (locale === "fr") return fr_launchpad__zois_cta_label(inputs)
	if (locale === "it") return it_launchpad__zois_cta_label(inputs)
	if (locale === "nl") return nl_launchpad__zois_cta_label(inputs)
	return pt_launchpad__zois_cta_label(inputs)
};